import "./alpine-store";
import "./alpine-data";
import "./alpine-plugins";

window.lazyLoadInstance = new window.LazyLoad({
  threshold: 800,
  use_native: false,
});

window.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

function onNextFrame(cb) {
  if (window.requestAnimationFrame) {
    requestAnimationFrame(cb);
  } else {
    setTimeout(cb, 16);
  }
}

document.addEventListener("alpine:initialized", () => {
  onNextFrame(() => {
    window.lazyLoadInstance.update();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  onNextFrame(() => {
    window.Alpine.start();
  });
});
